import moment from "moment-timezone";

/**
 * Get the appropriate client time for a given date based on the user set time zone
 */
export function getClientTime(time: Date, userTimeZone?: string) {
  if (userTimeZone) {
    return moment(time).tz(userTimeZone).format("M/D/YYYY, h:mm:ss A");
  } else {
    return new Date(time).toLocaleString();
  }
}
